import { inject, Injectable } from "@angular/core";
import { AppConfig } from "../config/app.config";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { MTAChangeTypeList, PolicyRiskSummary } from "../models/RequestQuote";
import { of } from "rxjs";
import { AuthService } from "../auth/auth.service";


@Injectable({
    providedIn: 'root'
})
export class PolicyAdministrationService{
    private apiUrl = AppConfig.apiUrl;
    authservice = inject(AuthService)       
    private token = this.authservice.getToken()
    httpClient = inject(HttpClient);

    requestMTAChangeByBroker(payload: any) {
        const path=`/api/Policy/RequestPolicyMTA`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    quoteMTA(policyId: number, userId: number, payload: any) {
        const path=`/api/Policy/AcceptQuoteMTAByUWAdmin?policyId=${policyId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    declineMTA(policyId: number, payload: any){
        const path=`/api/Policy/DeclinePolicyMTA?policyId=${policyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    declineMTAByBroker(policyId: number, isExit: boolean = false) {
        const path=`/api/Policy/DeclinePolicyMTAByPosUser?policyId=${policyId}&isUWExit=${isExit}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    acceptMTAByBroker(policyId: number, userId: number) {
        const path=`/api/Policy/ChangeAcceptByPOSUser?policyId=${policyId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    getPolicyCoverageSummary(policyId: number, branchId: number) {
        const path=`/api/Policy/GetPolicyCoverageSummary?policyId=${policyId}&branchId=${branchId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getPolicyRiskSummary(policyId: number) {
        const path=`/api/Policy/GetPolicyRiskSummary?policyId=${policyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<PolicyRiskSummary>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getPolicyMTAChangeList() {
        const path=`/api/Policy/GetMTAChanges`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<MTAChangeTypeList[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getRequestChangeDetails(policyId: number) {
        const path=`/api/Policy/GetPolicyMTAById?policyId=${policyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    bindApprovedMTAPolicy(policyId: number, userId: number) {
        const path=`/api/Policy/PolicyBindByUW?policyId=${policyId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, null);
    }

    saveQuoteMTAChange(policyId: number, userId: number, payload: any){
        const path=`/api/Policy/PolicySubmitByUW?policyId=${policyId}&userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    isPolicyReview(): boolean{
        const isReview = sessionStorage.getItem('isReview');
        if(isReview){
          return isReview === "true";
        }else{
          return false;
        }
    }

    isQuoteMTA(): boolean{
        const isQuoteMTA = sessionStorage.getItem('isQuoteMTA');
        if(isQuoteMTA){
            return isQuoteMTA === "true";
        }else{
            return false;
        }
    }

    isMTA(): boolean{
        const isMTA = sessionStorage.getItem('isMTA');
        if(isMTA){
            return isMTA === "true";
        }else{
            return false;
        } 
    }
}